// Internationalisation (ADR 0006).
//
// Collaboration screens are written through i18n from their first string;
// older screens are not retrofitted yet. Each feature owns a namespace, so a
// translator works on one coherent file and a bundle carries only its own.
//
// English only for now. Indian languages are added as locales/<lang>/*.json and
// listed in `resources` — with the same rule as privacy notices (D-073): a
// translation is shipped only once somebody qualified has checked it.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import collaborationEn from './locales/en/collaboration.json';

export const NAMESPACES = ['collaboration'] as const;

void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  ns: NAMESPACES,
  defaultNS: 'collaboration',
  resources: {
    en: { collaboration: collaborationEn },
  },
  interpolation: {
    // React already escapes what it renders; escaping here as well would show
    // a name like "D'Souza" as "D&#39;Souza".
    escapeValue: false,
  },
  returnNull: false,
  // The library prints an advertisement to the console on start-up.
  showSupportNotice: false,
});

export default i18n;
